export enum APIAcknowledgementReason {
  Cleared = "Cleared",
  Terminated = "Terminated",
  Inactive = "Inactive merchant",
  TermNotice = "Termination notice sent",
  WarnNotice = "Warning notice sent",
}
